namespace GeniuzPOS.Inventory {
    export namespace IcStockAdjustInDtService {
        export const baseUrl = 'Inventory/IcStockAdjustInDt';

        export declare function Create(request: Serenity.SaveRequest<IcStockAdjustInDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockAdjustInDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockAdjustInDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockAdjustInDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockAdjustInDt/Create",
            Update = "Inventory/IcStockAdjustInDt/Update",
            Delete = "Inventory/IcStockAdjustInDt/Delete",
            Retrieve = "Inventory/IcStockAdjustInDt/Retrieve",
            List = "Inventory/IcStockAdjustInDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockAdjustInDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
